var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTickCircled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.03,
    height: 47.03,
    viewBox: "0 0 47.03 47.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.52,
    cy: 23.52,
    r: 21.68,
    style: {
      fill: "#c8c8c8",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "3.66451439683034px"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.82,13.86a20.55,20.55,0,0,0-3.71,3.32,68.85,68.85,0,0,0-8.2,11.3c-1.2,1.95-2.39,3.91-3.62,5.92l-1.65-1.79c-2.4-2.62-4.81-5.25-7.22-7.86-.28-.3-.33-.48,0-.74s.87-1,1.39-1.12,1.06.47,1.58.75c1.43.78,2.85,1.57,4.25,2.4a.7.7,0,0,0,1.05-.17A84.93,84.93,0,0,1,27,19.26,53,53,0,0,1,34,14a1.35,1.35,0,0,1,.8-.22h2Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTickCircled);
export default __webpack_public_path__ + "static/media/icon-tick-circled.894a6b8d.svg";
export { ForwardRef as ReactComponent };